import { jsxs, jsx } from 'react/jsx-runtime';
import { mergeStyleSets, FontWeights, NeutralColors, Stack, Icon, SharedColors, Link, Text } from '@fluentui/react';
import { AppContext } from '../../../../context/context.esm.js';
import { useBreakpoint } from '@agoras/hooks';
import { useTranslation } from 'react-i18next';
import { useContext, useCallback } from 'react';
import logger from '@agoras/logger';
import { headerContext } from '../../../context.esm.js';
import { taxonomyItems } from '../../../../../data/taxonomy.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var classNames = mergeStyleSets({
    textLink: {
        color: NeutralColors.gray160,
        fontWeight: FontWeights.semibold,
        marginRight: 8
    }
});
var AppsByIndustries = function(param) {
    var onLinkClick = param.onLinkClick;
    var _useBreakpoint = _sliced_to_array(useBreakpoint('xl'), 1), isXL = _useBreakpoint[0];
    var navigate = useContext(AppContext).navigate;
    var t = useTranslation('header').t;
    var handleLinkClick = useCallback(function(navigateOptions) {
        navigate(navigateOptions);
        onLinkClick();
    }, [
        navigate,
        onLinkClick
    ]);
    var handleLogLink = useCallback(function(name) {
        logger.info(JSON.stringify({
            key: 'AppsByIndustries',
            name: name
        }), _object_spread({
            action: 'MegaMenu',
            actionModifier: 'Click link'
        }, headerContext));
    }, []);
    return /*#__PURE__*/ jsxs(Stack, {
        wrap: true,
        horizontal: true,
        styles: {
            inner: {
                rowGap: isXL ? '24px' : '32px',
                columnGap: isXL ? '16px' : '32px'
            }
        },
        children: [
            taxonomyItems.industries.map(function(param) {
                var title = param.title, icon = param.icon, navigateOptions = param.navigateOptions;
                return /*#__PURE__*/ jsx(Stack.Item, {
                    basis: "calc((100% - ".concat(isXL ? 32 : 64, "px) * (1 / 3))"),
                    children: /*#__PURE__*/ jsxs(Stack, {
                        horizontal: true,
                        tokens: {
                            childrenGap: 20
                        },
                        verticalAlign: "center",
                        children: [
                            /*#__PURE__*/ jsx(Stack.Item, {
                                children: /*#__PURE__*/ jsx(Icon, {
                                    iconName: icon,
                                    styles: {
                                        root: {
                                            fontSize: 20,
                                            color: SharedColors.cyanBlue10
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ jsx(Stack.Item, {
                                children: /*#__PURE__*/ jsx(Link, {
                                    onClick: function() {
                                        handleLogLink(title);
                                        handleLinkClick(navigateOptions);
                                    },
                                    children: /*#__PURE__*/ jsx(Text, {
                                        className: classNames.textLink,
                                        children: t(title)
                                    })
                                })
                            })
                        ]
                    })
                }, title);
            }),
            /*#__PURE__*/ jsx(Link, {
                onClick: function() {
                    handleLogLink('See all industries');
                    navigate({
                        type: 'App'
                    });
                    onLinkClick();
                },
                children: t('See all industries')
            })
        ]
    });
};

export { AppsByIndustries as default };
